// extracted by mini-css-extract-plugin
export var clients_served = "index-module--clients_served--WAbi8";
export var stats_wrapper = "index-module--stats_wrapper---y1tY";